import Y from "dayjs";
const M = "YYYY-MM-DD", m = "YYYY-MM", D = "DD.MM.YYYY", s = "MM.YYYY", H = "MMMM YYYY", o = "HH:mm", r = "HH:mm:ss", t = "DD.MM.YYYY HH:mm", a = "DD.MM.YYYY, h:mm:ss", f = "DD.MM.YYYY, HH:mm:ss", p = (M2, m2 = D, s2, H2 = "-") => M2 ? Y(M2, s2).format(m2) : H2;
export {
  D as DATE_FORMAT,
  t as DATE_TIME_FORMAT,
  a as DATE_TIME_FORMAT_EXTENDED,
  f as DATE_TIME_FORMAT_EXTENDED_24,
  M as ISO_DATE_FORMAT,
  m as ISO_MONTH_FORMAT,
  s as MONTH_DATE_FORMAT,
  H as MONTH_YEAR_FORMAT,
  o as TIME_FORMAT,
  r as TIME_FORMAT_EXTENDED,
  p as formatDate
};
//# sourceMappingURL=formatDate.js.map
